import { Box, Typography, CircularProgress, Card, Divider, CardContent, Grid, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import apiUrl from '../../Config';

const ViewUserDetails = () => {
    const location = useLocation();
    const userId = location?.state?.userId;

    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserBookings = async () => {
            try {
                const response = await axios.get(apiUrl + `/bookings/getuserbooking/${userId}`);
                if (response?.data.status === true) {
                    setBookings(response.data.getBookings);
                }

            } catch (err) {
                setError(err.message || 'Something went wrong');
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchUserBookings();
        }
    }, [userId]);

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Box p={4}>
            <Typography variant="h4" gutterBottom>
                User Booking Details
            </Typography>

            {bookings.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>

                    <Typography textAlign={'center'}>No bookings found for this user.</Typography>
                </Box>
            ) : (
                bookings.map((booking, index) => (
                    <Card key={index} variant="outlined" sx={{ mb: 4 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Booking ID: {booking.id}
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Typography>
                                        <strong>Booking Date:</strong>{' '}
                                        {(booking.bookingDate)}
                                    </Typography>
                                    <Typography>
                                        <strong>Status:</strong>{' '}
                                        <Chip
                                            label={booking.bookingStatus}
                                            color={
                                                booking.bookingStatus === 'deliveryTransit'
                                                    ? 'warning'
                                                    : 'success'
                                            }
                                            size="small"
                                        />
                                    </Typography>
                                    <Typography>
                                        <strong>Total Amount:</strong> ₹{booking.totalAmount}
                                    </Typography>
                                    <Typography>
                                        <strong>Delivery Charges:</strong> ₹{booking.deliveryAmount}
                                    </Typography>
                                    <Typography>
                                        <strong>Delivered Via:</strong> {booking.deliveredvia}
                                    </Typography>
                                    <Typography>
                                        <strong>Tracking ID:</strong> {booking.trackId}
                                    </Typography>
                                    {console.log(booking?.reciptUrl)}
                                    {booking?.reciptUrl &&
                                        <>
                                            <Typography>
                                                <strong>Receipt:</strong>{' '}
                                            </Typography>
                                            <img
                                                src={booking.reciptUrl}
                                                target="_blank"
                                                style={{ width: "150px", height: "150px" }}
                                            />
                                        </>



                                    }
                                </Grid>

                                <Grid item size={{ xs: 12, md: 6 }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>User Address:</strong>
                                    </Typography>
                                    <Typography><strong>Name:</strong> {booking.userAddress?.name}</Typography>
                                    <Typography><strong>Phone:</strong> {booking.userAddress?.phoneNumber}</Typography>
                                    <Typography sx={{ whiteSpace: 'pre-line' }}>
                                        {booking.userAddress?.parentName},
                                        {booking.userAddress?.houseNo}, {booking.userAddress?.street}, {booking.userAddress?.landmark},
                                        {booking.userAddress?.villageOrTown}, {booking.userAddress?.city},
                                        {booking.userAddress?.mandal}, {booking.userAddress?.district}, {booking.userAddress?.state},{"\n"}
                                        {booking.userAddress?.country} - {booking.userAddress?.pincode}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 2 }} />

                            <Typography variant="subtitle1" gutterBottom>
                                Ordered Items:
                            </Typography>
                            <Grid container spacing={2}>
                                {booking.booking_items?.map((item, i) => (
                                    <Grid item size={{ xs: 12, md: 6 }} key={i}>
                                        <Box sx={{ border: '1px solid #ddd', borderRadius: 2, p: 2 }}>
                                            <Typography>
                                                <strong>Book:</strong> {item.book?.title}
                                            </Typography>
                                            <Typography>
                                                <strong>Author:</strong> {item.book?.author?.name}
                                            </Typography>
                                            <Typography>
                                                <strong>Quantity:</strong> {item.quantity}
                                            </Typography>
                                            <Typography>
                                                <strong>Unit Price:</strong> ₹{item.unitPrice}
                                            </Typography>

                                            {item.book?.bookImages?.[0]?.imageUrl && (
                                                <Box mt={1}>
                                                    <img
                                                        src={item.book.bookImages[0].imageUrl}
                                                        alt="Book Cover"
                                                        width={100}
                                                        height={100}
                                                        style={{ borderRadius: 6 }}
                                                    />
                                                </Box>
                                            )}
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                ))
            )}
        </Box>
    );
};

export default ViewUserDetails;
